module.exports = __webpack_public_path__ + "img/rage-of-the-sea.db4871a0.jpg";